import React, { ReactElement } from 'react'
import styles from './StarRating.module.css'
import Image from 'next/image'
const GREEN_STAR = '/images/icons/green-star.svg';
const EMPTY_STAR = '/images/icons/empty-star.svg'

const Rating = ({ rating }: { rating: number }): ReactElement => {
  const stars = [0, 0, 0, 0, 0].map((star, index) =>
    index + 0.5 <= rating / 2 ? GREEN_STAR : EMPTY_STAR,
  )
  return (
    <div className={styles.ratingBar}>
      {stars.map((star, index) => (
        <div key={`star-${index}`} className={styles.starIcon}>
          <Image src={star} alt="star" height={16} width={16} />
        </div>
      ))}
    </div>
  )
}

export default Rating
